(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-panel-tipsen/assets/javascripts/hot-icon.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-panel-tipsen/assets/javascripts/hot-icon.js');
"use strict";

const {
  ReactIcon
} = svs.ui;
const HotIcon = () => React.createElement(ReactIcon, {
  className: "summary-item-icon-hot",
  color: "fc-red",
  icon: "hot"
});
setGlobal('svs.components.tipsen.drawPanelTipsen.HotIcon', HotIcon);

 })(window);